// Redux
import { combineReducers } from 'redux';

// Reducers
import { DemographicsReducer } from '../Demographics/reducers/demographics.reducer';
import { EngagementReducer } from '../Engagement/reducers/engagement.reducer';
import { ProspectProfileReducer } from '../ProspectProfile/reducers/prospectProfile.reducer';
import { ListMembershipReducer } from '../ListMembership/reducers/listMembership.reducer';
import { LocationsReducer } from '../Locations/reducers/LocationsReducer';
import { QueryReducer } from '../reducers/query.reducer';

export const FilterReducer = combineReducers({
  demographics: DemographicsReducer,
  engagement: EngagementReducer,
  prospectProfile: ProspectProfileReducer,
  listMembership: ListMembershipReducer,
  locations: LocationsReducer,
  query: QueryReducer,
});
